import { render, staticRenderFns } from "./PaginationWithdrawLayout.vue?vue&type=template&id=1900b130&scoped=true&"
import script from "./PaginationWithdrawLayout.vue?vue&type=script&lang=js&"
export * from "./PaginationWithdrawLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1900b130",
  null
  
)

export default component.exports